import Modal from "../../../elements/Modal";
import AllMediaList from "./AllMediaList";

const SelectedMedia = ({
  open,
  close = () => { },
  getResponse = () => { },
  data = {},
  onSelect = () => { },
  selectedData,
  isSingle,
}) => {
  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={() => {
          close();
        }}
        title={"Select Media"}
        size="xl8"
        modaltitleClasses={"!text-slate-200 text-[15px]"}
        headerClass={""}
        titleIcon={"titleIcon"}
        subtitle={"Create a new folder to organize your files."}
        modalDialogueStyle={"!bg-gray-100"}
      >
        <div className="space-y-4 w-full flex flex-col">
          <AllMediaList
            onSelect={onSelect}
            close={close}
            selectedData={selectedData}
            isSingle={isSingle}
          />
        </div>
      </Modal>
    </>
  );
};

export default SelectedMedia;
